import { createContext } from 'react'

export type setter = { set: (value: unknown) => void }

export const dataTransferContext = createContext<{ data: unknown } & setter>({ data: null } as { data: unknown } & setter)
export const {
  Provider: DataTransferProvider,
  Consumer: DataTransferConsumer,
} = dataTransferContext